'use strict';

function readDir(file, opt, cb) {
  // Do nothing for now
  cb(null, file);
}

module.exports = readDir;



//////////////////
// WEBPACK FOOTER
// ./~/vinyl-fs/lib/src/getContents/readDir.js
// module id = 4044
// module chunks = 0